import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { SessionContextProvider } from '@supabase/auth-helpers-react';
import { UserProvider } from './UserContext';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LandingPage from './components/LandingPage';
import WorkspaceView from './components/WorkspaceView/WorkspaceView';
import BasketContent from './components/BasketContent';
import AuthPage from './components/Auth/AuthPage';
import ForgotPassword from './components/Auth/ForgotPassword';
import ResetPassword from './components/Auth/ResetPassword';
import WorkspaceDetail from './components/WorkspaceDetail/WorkspaceDetail';
import TopicDetail from './components/TopicDetail/TopicDetail';
import { useDispatch } from 'react-redux';
import { setTopics } from './store/topicsSlice';
import ProtectedRoute from './components/ProtectedRoute';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfService from './components/TermsOfService';
import AcceptBasketPage from './components/AcceptBasket/AcceptBasketPage';

function AppContent() {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const { data, error } = await supabase
          .from('topics')
          .select(`
            id,
            name,
            workspace_id,
            basket_id,
            tag:tags(id, name, color)
          `)
          .limit(100);
        
        if (error) throw error;
        
        dispatch(setTopics(data));
      } catch (error) {
        console.error('Error fetching topics:', error);
      }
    };

    fetchTopics();
  }, [dispatch]);

  return (
    <Router>
      <div className="App">
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/auth/forgot-password" element={<ForgotPassword />} />
          <Route path="/auth/reset-password" element={<ResetPassword />} />
          <Route path="/workspace" element={
            <ProtectedRoute>
              <WorkspaceView />
            </ProtectedRoute>
          } />
          <Route path="/basket/:id" element={
            <ProtectedRoute>
              <BasketContent />
            </ProtectedRoute>
          } />
          <Route path="/accept-basket" element={
            <ProtectedRoute>
              <AcceptBasketPage />
            </ProtectedRoute>
          } />
          <Route path="/workspace/:workspaceId" element={
            <ProtectedRoute>
              <WorkspaceDetail />
            </ProtectedRoute>
          } />
          <Route path="/topic-detail/:topicId" element={
            <ProtectedRoute>
              <TopicDetail />
            </ProtectedRoute>
          } />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </div>
    </Router>
  );
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SessionContextProvider supabaseClient={supabase}>
          <UserProvider>
            <AppContent />
          </UserProvider>
        </SessionContextProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
